import React, { useState, useEffect } from 'react';
import { IoMdEye } from 'react-icons/io';
import { Button, Pagination } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import ViewWeightDisputes from '../../../component/b2c/models/viewWeightDisputes';
import { useMyContext } from '../../../context/MyContext';
import Sidebar from '../../../component/b2c/sidebar/sidebar';
import NavBar from '../../../component/b2c/navBar/navBar';
import PaginationItem from '@mui/material/PaginationItem';
import '../../../css/custom-scrollbar.css';
import { FaWeight } from 'react-icons/fa'
import { MdCheckCircle, MdCancel } from "react-icons/md";
import axios from 'axios';
import { FaDownload } from "react-icons/fa";
import { toast } from 'react-toastify';
import { dispute_action_admin, Base_Url, weightList } from '../../../config/config';

const AllWeightDisputes = () => {
    const [totalOrders, setTotalOrders] = useState(0);
    const { isDarkMode } = useMyContext();
    const [isPopupOpen, setIsPopupOpen] = useState(false);
    const { isToggleSidebar } = useMyContext();
    const [weights, setweights] = useState([]);
    const [selectedweight, setSelectedweight] = useState(null);
    const navigate = useNavigate();

    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(10);

    useEffect(() => {
        fetchAllDisputes();
    }, [page, limit]);

    const downloadCSV = () => {
        if (!weights || weights.length === 0) {
            toast.error("No data available to download");
            return;
        }

        const headers = [
            "Seller ID",
            "Waybill",
            "Initial Weight",
            "Dimension",
            "Product Description",
            "SKU",
            "Reversed Weight",
            "Price",
            "Status",
            "Date"
        ];

        const csvData = weights.map(weight => [
            weight.seller_id || '',
            weight.waybill || '',
            weight.initial_weight || '',
            weight.dimension || '',
            weight.product_des || '',
            weight.sku || '',
            weight.reversed_weight || '',
            weight.price || '',
            weight.status || '',
            weight.timestamp || ''
        ]);

        csvData.unshift(headers);

        const csvContent = csvData.map(row =>
            row.map(field => {
                const stringField = String(field);
                if (stringField.includes(',') || stringField.includes('"') || stringField.includes('\n')) {
                    return `"${stringField.replace(/"/g, '""')}"`;
                }
                return stringField;
            }).join(',')
        ).join('\n');

        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
        const link = document.createElement('a');
        const url = URL.createObjectURL(blob);
        link.setAttribute('href', url);
        link.setAttribute('download', `weight_disputes_${new Date().toISOString().split('T')[0]}.csv`);
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        toast.success("CSV file downloaded successfully!");
    };

    const handleAccept = async (row) => {
        const token = localStorage.getItem('token');
        const cus_id = localStorage.getItem('cus_id');
        const formData = new FormData();
        formData.append("waybill", row.waybill);
        formData.append("status", "Accept");
        formData.append("seller_id", row.seller_id);

        try {
            const response = await axios.post(Base_Url + dispute_action_admin, formData, {
                headers: {
                    'Content-Type': 'application/json',
                    'token': token,
                    'cus_id': cus_id,
                },
            });
            if (response.data.status === "SUCCESS") {
                toast.success(response.data.message);
                fetchAllDisputes();
            } else {
                toast.error(response.data.message);
            }
        } catch (error) {
            toast.error("Error uploading data: " + error.message);
        }
    };

    const handleReject = async (row) => {
        const token = localStorage.getItem('token');
        const cus_id = localStorage.getItem('cus_id');

        const formData = new FormData();
        formData.append("waybill", row.waybill);
        formData.append("status", "Raise");
        formData.append("seller_id", row.seller_id);

        try {
            const response = await axios.post(Base_Url + dispute_action_admin, formData, {
                headers: {
                    'Content-Type': 'application/json',
                    'token': token,
                    'cus_id': cus_id,
                },
            });
            if (response.data.status === "SUCCESS") {
                toast.success(response.data.message);
                fetchAllDisputes();
            } else {
                toast.error(response.data.message);
            }
        } catch (error) {
            toast.error("Error uploading data: " + error.message);
        }
    };

    const fetchAllDisputes = async () => {
        const token = localStorage.getItem('token');
        const cusid = localStorage.getItem('cus_id');
        try {
            const pageNumber = Number(page) || 1;
            const limitNumber = Number(limit) || 10;
            const urlweight = `${Base_Url}${weightList}?page=${pageNumber}&limit=${limitNumber}`;
            const response = await fetch(urlweight, {
                method: 'GET',
                headers: {
                    token,
                    cus_id: cusid,
                    'Content-Type': 'application/json',
                },
            });

            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }

            const result = await response.json();
            if (result.status === "SUCCESS") {
                setweights(result.data);
                setTotalOrders(result.pagination.total_records);
            } else {
                toast.error(result.message || 'Failed to fetch weight disputes.');
            }
        } catch (error) {
            // toast.error('Something went wrong!');
        }
    };

    const handlePaginationChange = (event, value) => {
        setPage(value);
    };

    const handleLimitChange = (event) => {
        setLimit(event.target.value);
        setPage(1);
    };

    const handleViewClick = (weight) => {
        setSelectedweight(weight);
        setIsPopupOpen(true);
    };

    const handleClose = () => {
        setIsPopupOpen(false);
    };

    const handleNavigation = () => {
        navigate('/dashboard');
    };

    const glass =
        "backdrop-blur-2xl backdrop-saturate-150 bg-white/50 dark:bg-white/[0.06] " +
        "border border-white/60 dark:border-white/10 " +
        "shadow-[0_8px_32px_rgba(31,41,55,0.08)]";

    // ✅ Reusable dark theme classes
    const tableHeadClass = `text-[9px] uppercase tracking-wider sticky top-0 z-10 transition-colors duration-300 ${
        isDarkMode
            ? 'bg-gradient-to-r from-[#1F2937] via-[#1a2332] to-[#1F2937] text-gray-300 border-b border-gray-700'
            : 'bg-[#792CA2] text-white'
    }`;

    const tableRowClass = (index) => `transition-colors ${
        isDarkMode
            ? `bg-[#111827] hover:bg-[#1F2937] ${index % 2 === 0 ? '' : 'bg-[#0F172A]'}`
            : `bg-white hover:bg-gray-50`
    }`;

    const tableBodyClass = `divide-y transition-colors duration-300 ${
        isDarkMode ? 'divide-gray-800' : 'divide-gray-100'
    }`;

    const cellTextClass = isDarkMode ? 'text-gray-300' : 'text-gray-700';
    const cellBoldClass = isDarkMode ? 'text-gray-100' : 'text-gray-800';
    const monoClass = `font-mono ${isDarkMode ? 'text-indigo-300' : 'text-gray-700'}`;

    const getStatusBadgeClass = (status) => {
        if (isDarkMode) {
            switch (status) {
                case 'Accept':
                    return 'bg-emerald-500/10 text-emerald-300 border-emerald-500/40 shadow-[0_0_10px_rgba(16,185,129,0.2)]';
                case 'Reject':
                case 'Raise':
                    return 'bg-rose-500/10 text-rose-300 border-rose-500/40 line-through';
                case 'close':
                    return 'bg-gray-500/10 text-gray-400 border-gray-600/40';
                case 'Pending':
                    return 'bg-amber-500/10 text-amber-300 border-amber-500/40';
                default:
                    return 'bg-indigo-500/10 text-indigo-300 border-indigo-500/30';
            }
        } else {
            switch (status) {
                case 'Accept':
                    return 'border-gray-800 text-gray-800';
                case 'Reject':
                case 'Raise':
                    return 'border-gray-300 text-gray-400 line-through';
                case 'close':
                    return 'border-gray-300 text-gray-400';
                case 'Pending':
                    return 'border-gray-800 text-gray-800 bg-gray-50';
                default:
                    return 'border-gray-200 text-gray-500';
            }
        }
    };

    const getStatusDotClass = (status) => {
        if (isDarkMode) {
            if (status === 'Accept') return 'bg-emerald-400 animate-pulse';
            if (status === 'Pending') return 'bg-amber-400 animate-pulse';
            if (status === 'Reject' || status === 'Raise') return 'bg-rose-400';
            return 'bg-gray-500';
        } else {
            if (status === 'Accept' || status === 'Pending') return 'bg-gray-800';
            return 'bg-gray-400';
        }
    };

    const emptyRowClass = `p-6 text-center text-[10px] ${isDarkMode ? 'text-gray-500' : 'text-gray-400'}`;

    return (
        <>
            <div className={`h-screen flex flex-col overflow-hidden transition-colors duration-300 ${isDarkMode ? 'dark bg-[#0B1120]' : 'bg-gray-50'}`}>
                <div className="pointer-events-none absolute -top-32 -left-24 h-96 w-96 rounded-full bg-indigo-200/30 dark:bg-indigo-500/10 blur-3xl" />

                <NavBar />
                <div className="flex flex-1 overflow-hidden">
                                     <div
            className={`
              ${isToggleSidebar ? "w-64" : "w-[72px]"}
              m-3
              rounded-3xl
              ${glass}
              overflow-hidden
              transition-all
              duration-300
              ease-in-out
            `}
          >
            <Sidebar />
          </div>

                    <div className={`flex-1 p-3 md:p-4 w-full overflow-hidden flex flex-col transition-colors duration-300 ${isDarkMode ? 'bg-[#0B1120]' : 'bg-gray-200'}`}>

                        {/* Header */}
                        <div className="flex-shrink-0 flex items-center gap-3 mb-3">
                            <div className={`p-2 rounded-lg border transition-all duration-300 ${isDarkMode ? 'bg-gradient-to-br from-[#1F2937] to-[#111827] border-gray-700 shadow-[0_0_15px_rgba(168,85,247,0.15)]' : 'bg-white border-gray-200'}`}>
                                <FaWeight className={`w-4 h-4 ${isDarkMode ? 'text-purple-400' : 'text-gray-600'}`} />
                            </div>
                            <div>
                                <h1 className={`text-sm font-bold tracking-tight transition-colors duration-300 ${isDarkMode ? 'text-white' : 'text-gray-800'}`}>Weight Disputes</h1>
                                <p className={`text-[9px] transition-colors duration-300 ${isDarkMode ? 'text-gray-500' : 'text-gray-400'}`}>Manage and resolve weight dispute claims</p>
                            </div>
                            <span className={`ml-auto text-[9px] font-medium px-3 py-1 rounded-full border transition-colors duration-300 ${isDarkMode ? 'text-purple-300 border-purple-500/30 bg-purple-500/10' : 'text-gray-500 border-gray-200'}`}>
                                {totalOrders} total
                            </span>
                        </div>

                        {/* Actions */}
                        <div className="flex-shrink-0 flex flex-col sm:flex-row items-center gap-2 mb-3">
                            <button
                                onClick={handleNavigation}
                                className={`w-full sm:w-auto px-4 py-1.5 text-[10px] font-semibold rounded-lg transition-all flex items-center justify-center gap-1.5 ${
                                    isDarkMode
                                        ? 'bg-gradient-to-r from-purple-600 to-indigo-600 text-white hover:shadow-[0_0_15px_rgba(168,85,247,0.5)]'
                                        : 'bg-[#792CA2] text-white hover:opacity-80'
                                }`}
                            >
                                <FaWeight size={11} />
                                All Weight Disputes
                            </button>

                            <button
                                onClick={downloadCSV}
                                disabled={!weights || weights.length === 0}
                                className={`w-full sm:w-auto px-4 py-1.5 text-[10px] font-semibold rounded-lg border transition-all flex items-center justify-center gap-1.5 disabled:opacity-40 disabled:cursor-not-allowed ${
                                    isDarkMode
                                        ? 'border-indigo-500/40 text-indigo-300 hover:bg-indigo-500/10'
                                        : 'border-gray-600 text-gray-600 hover:bg-gray-100'
                                }`}
                            >
                                <FaDownload size={11} />
                                Download CSV
                            </button>
                        </div>

                        {/* Table */}
                        <div className={`flex-1 overflow-y-auto overflow-x-auto rounded-lg border custom-scrollbar transition-colors duration-300 ${
                            isDarkMode
                                ? 'border-gray-800 bg-[#111827] shadow-[0_0_30px_rgba(0,0,0,0.4)]'
                                : 'border-gray-200'
                        }`}>
                            <table className="min-w-full table-auto">
                                <thead className={tableHeadClass}>
                                    <tr>
                                        <th className='px-2.5 py-1.5 text-left font-semibold'>Seller ID</th>
                                        <th className='px-2.5 py-1.5 text-left font-semibold'>Waybill</th>
                                        <th className='px-2.5 py-1.5 text-left font-semibold'>Init. Wt</th>
                                        <th className='px-2.5 py-1.5 text-left font-semibold'>Dimension</th>
                                        <th className='px-2.5 py-1.5 text-left font-semibold'>Product</th>
                                        <th className='px-2.5 py-1.5 text-left font-semibold'>SKU</th>
                                        <th className='px-2.5 py-1.5 text-left font-semibold'>Rev. Wt</th>
                                        <th className='px-2.5 py-1.5 text-left font-semibold'>Price</th>
                                        <th className='px-2.5 py-1.5 text-left font-semibold'>Status</th>
                                        <th className='px-2.5 py-1.5 text-left font-semibold'>Date</th>
                                        <th className='px-2.5 py-1.5 text-left font-semibold'>Action</th>
                                    </tr>
                                </thead>
                                <tbody className={tableBodyClass}>
                                    {weights.map((weight, index) => (
                                        <tr key={weight.id} className={tableRowClass(index)}>
                                            <td className={`px-2.5 py-1.5 text-[10px] font-medium whitespace-nowrap ${cellTextClass}`}>{weight.seller_id}</td>
                                            <td className={`px-2.5 py-1.5 text-[10px] font-medium whitespace-nowrap ${monoClass}`}>
                                                {weight.waybill}
                                            </td>
                                            <td className={`px-2.5 py-1.5 text-[10px] whitespace-nowrap ${cellTextClass}`}>{weight.initial_weight}</td>
                                            <td className={`px-2.5 py-1.5 text-[10px] whitespace-nowrap ${cellTextClass}`}>{weight.dimension}</td>
                                            <td className='px-2.5 py-1.5 max-w-[120px]'>
                                                {weight.product_des?.length > 15 ? (
                                                    <div className="group relative">
                                                        <span className={`text-[10px] cursor-pointer ${cellTextClass}`}>
                                                            {weight.product_des.substring(0, 15)}...
                                                        </span>
                                                        <div className={`absolute bottom-full left-1/2 transform -translate-x-1/2 mb-1.5 px-2 py-1 text-[9px] rounded shadow-lg opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none whitespace-nowrap z-50 ${
                                                            isDarkMode
                                                                ? 'bg-[#1F2937] text-gray-200 border border-gray-700'
                                                                : 'bg-gray-800 text-white'
                                                        }`}>
                                                            {weight.product_des}
                                                            <div className={`absolute top-full left-1/2 transform -translate-x-1/2 w-0 h-0 border-l-4 border-r-4 border-t-4 border-transparent ${
                                                                isDarkMode ? 'border-t-[#1F2937]' : 'border-t-gray-800'
                                                            }`}></div>
                                                        </div>
                                                    </div>
                                                ) : (
                                                    <span className={`text-[10px] ${cellTextClass}`}>{weight.product_des}</span>
                                                )}
                                            </td>
                                            <td className={`px-2.5 py-1.5 text-[10px] whitespace-nowrap ${cellTextClass}`}>{weight.sku}</td>
                                            <td className={`px-2.5 py-1.5 text-[10px] font-semibold whitespace-nowrap ${cellBoldClass}`}>{weight.reversed_weight}</td>
                                            <td className={`px-2.5 py-1.5 text-[10px] font-semibold whitespace-nowrap ${isDarkMode ? 'text-emerald-400' : 'text-gray-800'}`}>₹{weight.price || 'N/A'}</td>
                                            <td className='px-2.5 py-1.5'>
                                                <span className={`inline-flex items-center px-2 py-0.5 rounded-full text-[9px] font-semibold border transition-colors duration-300 ${getStatusBadgeClass(weight.status)}`}>
                                                    <span className={`w-1.5 h-1.5 rounded-full mr-1 ${getStatusDotClass(weight.status)}`}></span>
                                                    {weight.status}
                                                </span>
                                            </td>
                                            <td className={`px-2.5 py-1.5 text-[9px] whitespace-nowrap ${isDarkMode ? 'text-gray-400' : 'text-gray-500'}`}>{weight.timestamp}</td>
                                            <td className='px-2.5 py-1.5'>
                                                <div className='flex items-center gap-1'>
                                                    <button
                                                        onClick={() => handleViewClick(weight)}
                                                        className={`w-7 h-7 flex items-center justify-center rounded-md border transition-all ${
                                                            isDarkMode
                                                                ? 'border-indigo-500/40 text-indigo-300 hover:bg-indigo-500/10 hover:shadow-[0_0_8px_rgba(99,102,241,0.4)]'
                                                                : 'border-gray-300 text-gray-600 hover:bg-gray-100'
                                                        }`}
                                                        title="View"
                                                    >
                                                        <IoMdEye size={13} />
                                                    </button>
                                                    <button
                                                        onClick={() => handleAccept(weight)}
                                                        disabled={weight.status === "Accept" || weight.status === "close"}
                                                        className={`w-7 h-7 flex items-center justify-center rounded-md transition-all ${
                                                            weight.status === "Accept" || weight.status === "close"
                                                                ? (isDarkMode
                                                                    ? 'border border-gray-700 text-gray-600 cursor-not-allowed'
                                                                    : 'border border-gray-200 text-gray-300 cursor-not-allowed')
                                                                : (isDarkMode
                                                                    ? 'bg-gradient-to-r from-emerald-600 to-green-600 text-white hover:shadow-[0_0_10px_rgba(16,185,129,0.5)]'
                                                                    : 'bg-gray-800 text-white hover:opacity-80')
                                                        }`}
                                                        title="Accept"
                                                    >
                                                        <MdCheckCircle size={13} className={weight.status === "Accept" || weight.status === "close" ? (isDarkMode ? 'text-gray-600' : 'text-gray-300') : 'text-white'} />
                                                    </button>
                                                    <button
                                                        onClick={() => handleReject(weight)}
                                                        disabled={weight.status === "Accept" || weight.status === "close"}
                                                        className={`w-7 h-7 flex items-center justify-center rounded-md border transition-all ${
                                                            weight.status === "Accept" || weight.status === "close"
                                                                ? (isDarkMode
                                                                    ? 'border-gray-700 text-gray-600 cursor-not-allowed'
                                                                    : 'border-gray-200 text-gray-300 cursor-not-allowed')
                                                                : (isDarkMode
                                                                    ? 'border-rose-500/40 text-rose-400 hover:bg-rose-500/10 hover:shadow-[0_0_8px_rgba(244,63,94,0.4)]'
                                                                    : 'border-gray-300 text-gray-600 hover:bg-gray-100')
                                                        }`}
                                                        title="Reject"
                                                    >
                                                        <MdCancel size={13} className={weight.status === "Accept" || weight.status === "close" ? (isDarkMode ? 'text-gray-600' : 'text-gray-300') : (isDarkMode ? 'text-rose-400' : 'text-red-500')} />
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                    ))}
                                    {weights.length === 0 && (
                                        <tr>
                                            <td colSpan="11" className={emptyRowClass}>
                                                No weight disputes found
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>

                        {/* Pagination */}
                        <div className={`flex-shrink-0 mt-3 pt-3 border-t flex flex-col sm:flex-row justify-between items-center gap-2 transition-colors duration-300 ${isDarkMode ? 'border-gray-800' : 'border-gray-200'}`}>
                            <span className={`text-[9px] font-medium ${isDarkMode ? 'text-gray-400' : 'text-gray-500'}`}>
                                Total: <span className={`font-semibold ${isDarkMode ? 'text-purple-300' : 'text-gray-800'}`}>{totalOrders}</span>
                            </span>
                            <div className="flex items-center gap-2">
                                <select
                                    id="limit"
                                    value={limit}
                                    onChange={handleLimitChange}
                                    className={`border rounded-lg px-2 py-1 text-[9px] focus:outline-none focus:ring-1 transition-colors duration-300 ${
                                        isDarkMode
                                            ? 'bg-[#1F2937] border-gray-700 text-gray-300 focus:ring-purple-500'
                                            : 'bg-white border-gray-300 text-gray-700 focus:ring-gray-400'
                                    }`}
                                >
                                    <option value={10}>10</option>
                                    <option value={15}>15</option>
                                    <option value={20}>20</option>
                                    <option value={totalOrders}>All</option>
                                </select>
                                <Pagination
                                    count={Math.ceil(totalOrders / limit)}
                                    page={page}
                                    onChange={handlePaginationChange}
                                    variant="outlined"
                                    shape="rounded"
                                    size="small"
                                    sx={{
                                        '& .MuiPaginationItem-root': {
                                            fontSize: '9px',
                                            borderColor: isDarkMode ? '#374151' : '#d1d5db',
                                            color: isDarkMode ? '#E5E7EB' : '#000',
                                            '&.Mui-selected': {
                                                backgroundColor: isDarkMode ? 'rgba(168,85,247,0.2)' : '#792CA2',
                                                color: isDarkMode ? '#d8b4fe' : '#fff',
                                                borderColor: isDarkMode ? '#a855f7' : '#792CA2',
                                                boxShadow: isDarkMode ? '0 0 10px rgba(168,85,247,0.4)' : 'none',
                                            },
                                            '&:hover': {
                                                backgroundColor: isDarkMode ? 'rgba(168,85,247,0.1)' : '#F3F4F6',
                                            }
                                        },
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <ViewWeightDisputes isopen={isPopupOpen} onClose={handleClose} allWeightDisputes={selectedweight} />
            </div>
        </>
    );
};

export default AllWeightDisputes;